import { render, staticRenderFns } from "./Ingresso_materiale.vue?vue&type=template&id=7b5ba671&"
import script from "./Ingresso_materiale.vue?vue&type=script&lang=js&"
export * from "./Ingresso_materiale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports